import { createContext } from "react";
import rootStore from "../stores/RootStore";

const RootStoreContext = createContext(rootStore);
export default RootStoreContext;
